module.exports = __webpack_public_path__ + "img/wind.399d6a9c.png";